export default {"src":"/_next/static/media/twitter.681dfe66.svg","height":32,"width":32};